"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _window = window,
    html = _window.html,
    url = _window.url,
    routes = _window.routes;

var _default = function _default(_ref) {
  var id = _ref.id,
      rid = _ref.rid,
      typeId = _ref.typeId,
      title = _ref.title,
      alignment = _ref.alignment,
      sampleHref = _ref.sampleHref,
      sampleText = _ref.sampleText,
      historyActionLabel = _ref.historyActionLabel,
      historyActionText = _ref.historyActionText,
      historyEnabled = _ref.historyEnabled,
      gaHistoryAction = _ref.gaHistoryAction,
      seriesSearchUrl = _ref.seriesSearchUrl;
  return "\n<div class=\"ContextMenu\">\n    <div tabindex=\"0\" class=\"ContextMenu-button js-context-button\" data-media-id=\"".concat(id, "\"\n         data-title=\"").concat(title, "\"\n         data-dropdown=\"context-menu-").concat(id, "-").concat(rid, "\"\n         data-options=\"align:").concat(alignment, "\"\n         aria-controls=\"more-actions-drop-").concat(id, "\"\n         aria-expanded=\"false\"\n         aria-label=\"").concat(html('cover.titleInfo', {
    title: title
  }), "\"\n         role=\"button\">\n        <i class=\"icon icon-more\" tabindex=\"-1\"></i>\n    </div>\n\n    <ul id=\"context-menu-").concat(id, "-").concat(rid, "\" class=\"ContextMenu-drop js-context-drop f-dropdown text-left\" data-dropdown-content aria-hidden=\"false\" tabindex=\"-1\" role=\"list\" aria-haspopup=\"true\">\n        ").concat(sampleHref !== '' ? "\n            <li class=\"read-sample ContextMenu-item\">\n                <a data-href=\"".concat(sampleHref, "\" data-media-id=\"").concat(id, "\" data-title=\"").concat(title, "\"\n                   data-of-dropdown=\"more-actions-drop-").concat(id, "\" data-type=\"").concat(typeId, "\"\n                   tabindex=\"-1\" href=\"javascript:void(0)\" aria-label=\"").concat(html('cover.sampleLabel', {
    sample: sampleText,
    title: title
  }), "\">\n                    ").concat(sampleText, "\n                </a>\n            </li>") : '', "\n        <li class=\"ContextMenu-item\">\n            <a tabindex=\"-1\" href=\"").concat(url(routes.mediaId, {
    id: id
  }), "\" aria-label=\"").concat(html('viewDetailsAboutTitle', {
    title: title
  }), "\">").concat(html('viewDetails'), "</a>\n        </li>\n        ").concat(seriesSearchUrl ? "\n            <li class=\"ContextMenu-item\"><a tabindex=\"-1\" href=\"".concat(seriesSearchUrl, "\">").concat(html('viewSeries'), "</a></li>") : '', "\n        ").concat(historyEnabled ? "<li class=\"ContextMenu-item js-historyAction\" data-ga-action=\"".concat(gaHistoryAction, "\" data-media-id=\"").concat(id, "\"><a tabindex=\"-1\" role=\"button\" aria-label=\"").concat(historyActionLabel, "\">").concat(historyActionText, "</a></li>") : "", "\n        <li class=\"ContextMenu-item\"><a tabindex=\"-1\" href=\"").concat(url(routes.mediaRelatedId, {
    id: id
  }), "\" aria-label=\"").concat(html('viewRelatedToTitle', {
    title: title
  }), "\">").concat(html('youMayAlsoLike'), "</a></li>\n    </ul>\n</div>");
};

exports["default"] = _default;